import { atom, useAtom } from 'jotai';
import { compile, match } from 'path-to-regexp';

import { SettingsPath } from '../routes';

import { PathParams } from '~/shared/routing/types';
import { atomFromQueryString } from '~/shared/state';

export const $settingsModuleLocation =
  atomFromQueryString.enum<SettingsPath>('settingsPath');

export const settingsRouteParamAtom = <P extends SettingsPath[]>(
  pathPatterns: P,
  key: keyof PathParams<P[number]>,
) =>
  atom(
    (get) => {
      const location = get($settingsModuleLocation);

      const allParams = pathPatterns.reduce((acc, path) => {
        const { params } = match(path)(location) as unknown as {
          params: PathParams<P[number]>;
        };
        return { ...acc, ...(params ?? {}) };
      }, {}) as PathParams<P[number]>;

      // const { params } = match(pathPattern)(location) as unknown as {
      //   params: PathParams<P[number]>;
      // };

      return allParams[key];
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (get, set, value: any) => {
      const location = get($settingsModuleLocation);

      const matchingPattern = pathPatterns.find((p) => match(p)(location));
      if (!matchingPattern) return;

      const { params } = match(matchingPattern)(location) as unknown as {
        params: PathParams<P[number]>;
      };
      const newPath = compile(matchingPattern)({
        ...(params as Record<string, string>),
        [key]: String(value),
      });
      set($settingsModuleLocation, newPath as SettingsPath);
    },
  );

export const useSettingsLocation = () => {
  const [settingsPath, setSettingsPath] = useAtom($settingsModuleLocation);
  return [settingsPath, setSettingsPath] as const;
};

export const matchesSettingsRoute = (
  location: string,
  ...routePatterns: SettingsPath[]
) => routePatterns.some((pattern) => match(pattern)(location));
